export default __webpack_public_path__ + "static/media/h-lr-b.ccd5c978.png";